import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ClaimMultiByIdUseCase } from 'src/app/features/claims/domain/usecases/get-claim-id-multi.usecase';
import { Failure, UnhandledFailure } from 'src/app/core/utils/failure';
import { ClaimMultiEntity } from 'src/app/features/claims/domain/entities/claim-multi.entity';
import { ClaimStatus } from 'src/app/core/enums/claim-status.enum';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { GetProvinceUseCase } from 'src/app/core/services/location/domain/usecases/get-province.usecase';
import { ProvinceEntity } from 'src/app/core/services/location/domain/entities/province.entity';
import { GetFileModel } from 'src/app/features/claims/data/models/get-file.model';
import { GetFileMultiUseCase } from 'src/app/features/claims/domain/usecases/get-file-multi.usecase';
import { UserRol } from 'src/app/core/enums/user-rol.enum';
import { UpdateClaimStatusModel } from 'src/app/features/claims/data/models/update-claim-status.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UpdateClaimStatusEntity } from 'src/app/features/claims/domain/entities/update-claim-satus.entity';
import { UpdateMultiClaimStatusUseCase } from 'src/app/features/claims/domain/usecases/update-multi-status.usecase';
import { Toast } from 'primeng/toast';
import { MinuteEntity } from 'src/app/features/minutes/domain/entities/minute.entity';
import { GetMinutesByClaimIdUseCase } from 'src/app/features/minutes/domain/usecases/get-minutes-by-claim-id.usecase';
import { DeleteActaUseCase } from 'src/app/features/minutes/domain/usecases/delete-acta.usecase';
import { GetFileBaseUseCase } from 'src/app/features/claims/domain/usecases/get-file-base.usecase';
import { GetFileBaseModel } from 'src/app/features/claims/data/models/get-file-base.model';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AudiencesService } from 'src/app/features/audiences/services/audiences.service';
import { Departament } from 'src/app/features/user/presentation/components/New-User-SuperAdmin/newUser.component';
import { GetDepartmentsByIdUseCase } from 'src/app/core/services/location/domain/usecases/get-department-by-id.usescase';

@Component({
  selector: 'app-claim-view-multi',
  templateUrl: './claim-view-multi.component.html',
  styleUrls: ['./claim-view-multi.component.css'],
  providers: [MessageService, Toast, ConfirmationService],
})
export class ClaimViewMultiComponent implements OnInit {
  private AES = new AESEncryptDecryptService();
  claim?: ClaimMultiEntity;
  claimForAudience?: any;
  isLoading: boolean = false;
  claimId?: string | null;
  userRol?: string;

  claimetProvince?: ProvinceEntity;
  provinces: ProvinceEntity[] = [];
  departamentName?: Departament;
  showFileDialog: boolean = false;
  urlFile: string = '';

  files?: string[];
  extrafiles?: string[];

  buttons: boolean = false;

  labelText: string = 'Aceptar';
  rejectDialogVisible: boolean = false;
  rejectionReason: string = '';
  rejectionFileBase64?: string;
  audienciaDialogVisible: boolean = false;

  minutesForClaim?: MinuteEntity[];
  minuteDialogVisible: boolean = false;

  typeAdmitedClaimDialogVisible: boolean = false;
  resultIntimationAdmited?: boolean;
  typeAdmited: string = '';

  newStatusClaimUpdate?: UpdateClaimStatusModel;

  enableScroll: boolean = true;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageServiceBase,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private claimUseCase: ClaimMultiByIdUseCase,
    private getProvince: GetProvinceUseCase,
    private getFileUseCase: GetFileMultiUseCase,
    private updateClaimStatusUseCase: UpdateMultiClaimStatusUseCase,
    private getMinutesByClaimIdUseCase: GetMinutesByClaimIdUseCase,
    private deleteActaUseCase: DeleteActaUseCase,
    private getFileBaseUseCase: GetFileBaseUseCase,
    private getDepartmentsByIdUseCase: GetDepartmentsByIdUseCase
  ) {}

  async ngOnInit(): Promise<void> {
    this.claimId = this.route.snapshot.paramMap.get('id');
    this.userRol = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_rol')
    );
    await Promise.all([this.getClaim(), this.loadProvinces()]);
    this.setProvinceById();
    this.showButtons();
    this.getMinutesByClaimId();
  }

  goBack(): void {
    this.location.back();
  }

  //Status Info
  async getClaim(): Promise<void> {
    if (!this.claimId) return;
    this.isLoading = true;
    let result = await this.claimUseCase.execute(this.claimId!);
    if (result instanceof Failure) {
      this.isLoading = false;
      return;
    }
    this.claim = result;
    this.departamentName = await this.laodDepartments(this.claim.departmentId!);
    this.claimForAudience = Object.assign({}, result);
    this.files = result.file;
    this.extrafiles = result.extraDocumentationPdf;
    this.isLoading = false;
  }

  //State
  getStatusClass(status: string | undefined): string {
    switch (status) {
      case ClaimStatus.DRAFT:
        return 'status-draft';
      case ClaimStatus.PENDING:
        return 'status-pending';
      case ClaimStatus.REFUSED:
        return 'status-refused';
      case ClaimStatus.FINALIZED:
        return 'status-finalized';
      case ClaimStatus.IN_INTERNAL_PROCESS:
        return 'status-in-internal-process';
      case ClaimStatus.AUDIENCE_SET:
      case 'Audiencia Fijada':
        return 'status-audience-set';
      case ClaimStatus.ADMITTED:
        return 'status-admited';
      default:
        return '';
    }
  }

  //Provinces
  getProvinceName(provinceId: string): string {
    const province = this.provinces.find((p) => p.id === provinceId);
    return province ? province.name : provinceId;
  }

  async loadProvinces() {
    try {
      const result = await this.getProvince.execute();
      if (Array.isArray(result)) {
        this.provinces = result;
      }
    } catch (error) {
      throw new UnhandledFailure();
    }
    this.setProvinceById();
  }

  setProvinceById(): void {
    const provinceCompany = this.claim?.provinceCompany;
    this.claimetProvince =
      this.provinces.find((prov) => prov.id === provinceCompany) ||
      this.provinces.find((prov) => prov.name === provinceCompany);
  }

  async laodDepartments(id: string): Promise<Departament | undefined> {
    const result = await this.getDepartmentsByIdUseCase.execute(id);

    if (!(result instanceof Failure)) {
      return result;
    }
    return undefined;
  }

  showDialog(urlFile: string): void {
    this.urlFile = urlFile;
    this.showFileDialog = true;
  }

  onHide(): void {
    this.urlFile = '';
    this.showFileDialog = false;
  }

  async viewImage(fileName: string) {
    let fileData = new GetFileModel(this.claim?.id!, fileName);
    let file = await this.getFile(fileData);
    this.showDialog(file);
  }

  async getFile(param: GetFileModel): Promise<string> {
    let result = await this.getFileUseCase.execute(param);
    if (result instanceof Failure) {
      return result.message;
    }
    return result;
  }

  async downloadPdf(pdf: string, minuteId?: string) {
    let base64: string = '';
    if (minuteId) {
      let extraDocFiles = new GetFileBaseModel(minuteId!, pdf);
      base64 = await this.getFileBase(extraDocFiles);
    } else {
      let extraDocFiles = new GetFileModel(this.claim?.id!, pdf);
      base64 = await this.getFile(extraDocFiles);
    }

    let mimeType = 'application/pdf';
    let extension = 'pdf';

    switch (true) {
      case base64.startsWith('iVBORw0KGgo'):
        mimeType = 'image/png';
        extension = 'png';
        break;
      case base64.startsWith('/9j/'):
        mimeType = 'image/jpeg';
        extension = 'jpeg';
        break;
      default:
        mimeType = 'application/pdf';
        extension = 'pdf';
        break;
    }

    const link = document.createElement('a');
    link.href = `data:${mimeType};base64,${base64}`;
    link.download = `document.${extension}`;
    link.click();
  }

  showButtons() {
    if (
      this.userRol == UserRol.ADMINISTRATOR ||
      this.userRol == UserRol.CONCILIATOR
    ) {
      this.buttons = true;
    }
  }

  newMinuteCheck() {
    this.minuteDialogVisible = true;
  }

  async getMinutesByClaimId(): Promise<void> {
    let result = await this.getMinutesByClaimIdUseCase.execute(this.claimId!);
    if (result instanceof Failure) {
      return;
    }
    this.minutesForClaim = result;
  }

  deleteActa(id: string): void {
    this.confirmationService.confirm({
      header: 'Eliminar acta',
      message: '¿Está seguro que desea eliminar el acta?',
      accept: async () => {
        this.isLoading = true;
        let result = await this.deleteActaUseCase.execute(id);
        this.isLoading = false;
        if (result instanceof Failure) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar el acta.' });
          return;
        }
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Acta eliminada correctamente.' });
        await this.getMinutesByClaimId();
      },
    });
  }

  async getFileBase(param: GetFileBaseModel): Promise<string> {
    let result = await this.getFileBaseUseCase.execute(param);
    if (result instanceof Failure) {
      return result.message;
    }
    return result;
  }

  async viewMinutePdf(id: string, pdf: string) {
    let extraDocFiles = new GetFileBaseModel(id, pdf);
    this.urlFile = await this.getFileBase(extraDocFiles);
    this.showFileDialog = true;
  }

  newAudienceCheck() {
    this.audienciaDialogVisible = true;
  }

  cancel(close: any) {
    this.audienciaDialogVisible = false;
    this.minuteDialogVisible = false;
  }

  handleShowMessage(event: {
    severity: string;
    summary: string;
    detail: string;
  }) {
    this.messageService.add({
      severity: event.severity,
      summary: event.summary,
      detail: event.detail,
    });
    this.getClaim()
  }

  recibeAceptDialog(actionEvent: any): void {
    if (actionEvent == 'Admitir') {
      this.updateAdmittedStatusCheck();
    } else {
      this.updateRefucedStatusCheck();
    }
  }

  updateAdmittedStatusCheck() {
    this.labelText = 'Admitir reclamo';
    this.confirmationService.confirm({
      header: 'Admitir reclamo',
      message: `¿Desea admitir el reclamo?`,
      accept: () => {
        this.typeAdmitedClaimDialogVisible = true;
      },
    });
  }

  resultIntimationAdmitedEvent(event: boolean) {
    this.resultIntimationAdmited = event;
    if (!this.resultIntimationAdmited) {
      this.newStatusClaimUpdate = new UpdateClaimStatusModel(
        this.claimId!,
        ClaimStatus.ADMITTED
      );
      this.updateClaimStatus(this.newStatusClaimUpdate);
      this.typeAdmitedClaimDialogVisible = false;
    }
  }

  resultTypeAdmitedEvent(event: string) {
    this.typeAdmited = event;
    if (this.typeAdmited) {
      this.newStatusClaimUpdate = new UpdateClaimStatusModel(
        this.claimId!,
        ClaimStatus.ADMITTED,
        undefined,
        this.typeAdmited
      );
      this.updateClaimStatus(this.newStatusClaimUpdate);
      this.typeAdmitedClaimDialogVisible = false;
    }
  }

  async updateClaimStatus(claim: UpdateClaimStatusEntity): Promise<void> {
    this.isLoading = true;
    let result = await this.updateClaimStatusUseCase.execute(claim);
    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Estado no actualizado.',
        life: 900,
      });
      this.isLoading = false;
      return;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Estado actualizado',
      detail: 'El estado se actualizó exitosamente.',
    });
    this.isLoading = false;
    this.getClaim();
  }

  updateRefucedStatusCheck() {
    this.labelText = 'Rechazar reclamo';
    this.confirmationService.confirm({
      header: 'Rechazar reclamo',
      message: `¿Desea rechazar el reclamo?`,
      accept: () => {
        this.rejectDialogVisible = true;
      },
      reject: () => {
        this.rejectionReason = '';
        this.rejectionFileBase64 = undefined;
      },
    });
  }

  confirmRejection() {
    if (this.rejectionReason.trim() || this.rejectionFileBase64) {
      let newStatusClaimUpdate = new UpdateClaimStatusModel(
        this.claimId!,
        ClaimStatus.REFUSED,
        this.rejectionReason.trim() ? this.rejectionReason : undefined,
        undefined,
        this.rejectionFileBase64 ? [this.rejectionFileBase64] : undefined
      );
      this.updateClaimStatus(newStatusClaimUpdate);
      this.rejectDialogVisible = false;
      this.rejectionReason = '';
      this.rejectionFileBase64 = undefined;
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Debe especificar el motivo de rechazo o subir un archivo PDF.',
        life: 2000,
      });
    }
  }

  onRejectionFileUpload(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        this.messageService.add({
          severity: 'error',
          summary: 'Formato incorrecto',
          detail: 'El archivo debe ser un PDF.',
        });
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.rejectionFileBase64 = reader.result as string;
      };
      reader.readAsDataURL(file);
    } else {
      this.rejectionFileBase64 = undefined;
    }
  }

  removeRejectionFile(fileInput: any) {
    this.rejectionFileBase64 = undefined;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async downloadAsPdf() {
    const element = document.getElementById('claim-view');
    const downloadButton = document.querySelector(
      'p-button[label="Descargar"]'
    );

    if (!element) return;

    try {
      this.enableScroll = false;
      await this.delay(300);

      if (downloadButton) {
        downloadButton.classList.add('hidden');
      }

      const canvas = await html2canvas(element, {
        scale: 1.2,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.8);

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = 210;
      const pageHeight = 297;

      const aspectRatio = canvas.width / canvas.height;
      const imgWidth = pageWidth - 20;
      const imgHeight = imgWidth / aspectRatio;
      const xPosition = 10;
      let yPosition = 10;
      let heightLeft = imgHeight;

      pdf.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);
      heightLeft -= pageHeight - 20;

      while (heightLeft > 0) {
        pdf.addPage();
        pdf.addImage(
          imgData,
          'PNG',
          xPosition,
          yPosition - (imgHeight - heightLeft),
          imgWidth,
          imgHeight
        );
        heightLeft -= pageHeight - 20;
      }

      pdf.save('reclamo.pdf');
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Error al descargar el archivo.',
      });
      console.error('Error al descargar el archivo', error);
    } finally {
      this.enableScroll = true; // Restaurar scroll
      if (downloadButton) {
        downloadButton.classList.remove('hidden');
      }
    }
  }
}
